import { useState } from "react";
import { Box } from "@mui/material";
import HeaderComponent from "./header-component";
import NavComponent from "./nav-component";
import FooterComponent from "./footer-component";
import PropTypes from "prop-types";

AppLayout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default function AppLayout({ children }) {
  const [mobileOpen, setMobileOpen] = useState(false);
  const DRAWER_WIDTH = 280;

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
      }}
    >
      {/* Header (fixed height) */}
      <HeaderComponent
        onMenuClick={handleDrawerToggle}
        isMenuOpen={mobileOpen}
      />

      {/* Body Section */}
      <Box
        sx={{
          display: "flex",
          flexGrow: 1,
          overflow: "hidden",
        }}
      >
        {/* Sidebar */}
        <NavComponent
          mobileOpen={mobileOpen}
          onClose={handleDrawerToggle}
          sx={{
            width: DRAWER_WIDTH,
            flexShrink: 0,
            display: { xs: "none", md: "block" },
          }}
        />

        {/* Main Content */}
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            position: "relative",
            overflowY: "auto",
            ml: { sm: `${DRAWER_WIDTH}px`, md: `${DRAWER_WIDTH}px` },
            px: 2,
            pt: { xs: 14, sm: 12, md: 12 },
            pb: 3,
          }}
        >
          {children}
        </Box>
      </Box>

      {/* Footer */}
      <Box sx={{ zIndex: 1100 }}>
        <FooterComponent />
      </Box>
    </Box>
  );
}
